import api from "@/service/api";

const state = () => ({
    creatorStandardMap: null,
    creatorRequest: null,
    sentRequest: null,
    disputeRate: null,
    disputeRateAfter: null,
    creatorRequestConfig: null,
    creatorRequestDisputes: null,
    rectifiedDisputeIds: [],
})

const mutations = {
    reset(state) {
        state.creatorStandardMap = null
        state.sentRequest = null
        state.disputeRate = null
        state.disputeRateAfter = null
        state.creatorRequestConfig = null
        state.creatorRequestDisputes = null
        state.rectifiedDisputeIds = []
    },
    setCreatorStandardMap(state, value) {
        state.creatorStandardMap = value;
    },
    setCreatorRequest(state, value) {
        state.creatorRequest = value;
    },
    setSentRequest(state, value) {
        state.sentRequest = value;
    },
    setDisputeRate(state, value) {
        state.disputeRate = value;
    },
    setDisputeRateAfter(state, value) {
        state.disputeRateAfter = value;
    },
    setCreatorRequestConfig(state, value) {
        state.creatorRequestConfig = value;
    },
    setCreatorRequestDisputes(state, value) {
        state.creatorRequestDisputes = value;
    },
    appendRectifiedDisputeId(state, value) {
        state.rectifiedDisputeIds.push(value);
    },
}

const actions = {
    start({ commit }, creatorStandardMap) {
        commit('reset')
        commit('setCreatorStandardMap', creatorStandardMap)
        commit("interface/setCreatorRequestModalVisible", true, { root: true });
    },
    get({ commit }, creatorRequestId) {
        commit('reset')

        api.post("/creatorRequest/get", { creatorRequestId }).then(response => {
            commit('setCreatorRequest', response?.data?.creatorRequest)
            commit('setDisputeRate', response?.data?.disputeRate)
            commit('setDisputeRateAfter', response?.data?.disputeRateAfter)
            commit('setCreatorRequestConfig', response?.data?.creatorRequestConfig)
            commit('setCreatorRequestDisputes', response?.data?.creatorRequestDisputes)

            // only on the creator side do we fire this
            // helpful to know the creator has seen your request
            api.post("/creatorRequest/seen", {
                creatorRequestId,
            });
        })
    },
    decline({ dispatch, state }) {
        api.post("/creatorRequest/decline", {
            creatorRequestId: state.creatorRequest.id,
        }).then(function () {
            dispatch('refresh');
            dispatch('onboarding/status', null, { root: true });
        })
    },
    removeMedia({ dispatch, state }, userMediaId) {
        api.post("/creatorRequest/removeUserMedia", {
            creatorRequestId: state.creatorRequest.id,
            userMediaId
        }).then(() => dispatch('refresh'))
    },
    refresh({ state, dispatch }) {
        dispatch('get', state.creatorRequest.id)
    },
}


const getters = {
    unsettledDisputes: (state) => {
        return state.creatorRequestDisputes?.filter(creatorRequestDispute => !creatorRequestDispute.settled)
    }
}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}
